export default (theme) => ({
  root: {
    margin: 0,
    padding: 10,
    backgroundColor: "#e8e8e8",
  },
  documentsBarContainer: {
    padding: "8px 30px",
    backgroundColor: "#f3f3f3",
  },
  documentsBarTitle: {
    fontSize: 13,
    fontWeight: 600,
  },
  documentsTableContainer: {
    padding: "18px",
  }, 
  menuItem: {
    textDecoration: "none",
  },
});
